import { connect } from 'react-redux';
import { ICalendarSource } from '../../../../data/entities/calendar-source';
import { createCalendarSource } from '../../../../entities/calendar-source/actions';
import { IThunkDispatch } from '../../../../store/middleware';
import { CalendarSyncImportWizardActionComponent } from './CalendarSyncImportWizardAction';

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	createCalendarSource: (propertyId: string | number, calendarSource: ICalendarSource) =>
		dispatch(createCalendarSource(propertyId, calendarSource))
});

export const CalendarSyncImportWizardAction = connect(null, mapDispatchToProps)(CalendarSyncImportWizardActionComponent);
